import React, { useState, useEffect, useContext } from "react";
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Chip from '@material-ui/core/Chip';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import AddIcon from '@material-ui/icons/Add';

import withWidth from '@material-ui/core/withWidth';

import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';


import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';

import { DatePicker, TimePicker } from '../components/DatePicker';

import { API } from 'aws-amplify';
import { FullWidthTextField } from '../components/FullWidthTextField'
import LoadingButton from '../components/LoadingButton';
import LoadingDialog from './LoadingDialog';
import Toolbar from '@material-ui/core/Toolbar';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import DoneIcon from '@material-ui/icons/Done';
import CircularProgress from '@material-ui/core/CircularProgress';

const options = { weekday: 'short', month: 'numeric', day: 'numeric' };

const useStyles = makeStyles((theme) => ({
  small: {
    padding: theme.spacing(3),
    margin: 'auto',
    marginTop: '24px',
    [theme.breakpoints.up('sm')]: {
      maxWidth: `640px`,
    }
  },
  paper: {
    height: '100%',
    padding: theme.spacing(0, 1),
    overflowY: 'hidden'
  },
  paperContent: {
    height: '100%',
    overflowY: 'auto',
    overflowX: 'hidden'
  },
  iconRight: {
    position: 'absolute',
    right: '0px'
  },
  saveButton: {
    margin: theme.spacing (1),
  },
  root: {
    padding: theme.spacing(3)
  },
  datePicker: {
    width: '100%'
  },
  card: {
    height: '100%'
  },
  visIcon: {
    marginLeft: 'auto'
  },
  key: {
    margin: theme.spacing(1)
  },
  header2: {
    background: theme.palette.secondary.main
  }
}))
const reduceToLkp = (lkp, entry) => {
  var date = new Date(entry.from);
  var lkpStr = date.toLocaleDateString('de-DE', options);
  return {
    ...lkp,
    [lkpStr]: [
      ...(lkp[lkpStr] || []),
      entry
    ]
  }
}
const Overview = () => {
  const classes = useStyles();
  const [initialized, setInitialized] = useState(false);
  const [entries, setEntries] = useState([]);
  const [error, setError] = useState(null);
  const [visible, setVisible] = useState(localStorage.visible === "true" || false);

  const reload = async () => {
        const res = await API.get ('appointments', '/appointments');
        setEntries(res);
  }

  const handleVisibility = () => {
    localStorage.visible = !visible;
    setVisible(!visible);
  }

  useEffect (() => {
    if (!initialized)
    (async() => {
      try {
        await reload ()
        setInitialized(true);
      } catch (e) {
        setInitialized(true);
        setError (e);
      }
    })()
  })

  if (!initialized) {
    return <LoadingDialog>Termine werden geladen.</LoadingDialog>
  }

  if (error) {
    return <center>
      <Typography>Es konnten keine Termine geladen werden.</Typography>
    </center>
  }
  
  const filtered = entries.filter((entry) => {
    return entry.from > (+new Date - 1000 * 60 * 30)
  }).sort ((a, b) => {
    return a.from - b.from;
  }).filter ((entry) => {
    if (entry.cancelled) return true
    if (!visible) return !entry.marked;
    return true;
  })

  if (filtered.length === 0) {
    return <>
    <VisibilityToolbar visible={visible} onClick={handleVisibility}/>
      <center>
        <Paper className={classes.small}>
          <Typography>Momentan gibt es keine offenen Termine.</Typography>
        </Paper>
      </center>
    </>
  }
  const lkp = filtered.reduce (reduceToLkp, {});

  return <div>
    <VisibilityToolbar visible={visible} onClick={handleVisibility}/>
    {Object.keys(lkp).map ((key) => {
      return <div>
        <center><Typography className={classes.key} variant="h5">{key}</Typography></center>
        <hr></hr>
        <Grid className={classes.root} container xs={12} spacing={1}>
          {lkp[key].map ((entry) => {
            const {name, comment, phone, email, id, marked, cancelled} = entry;
            const date = new Date (entry.from);
            return <Grid item xs={12} sm={6} md={4}>
              <AptForm cancelled={cancelled} reload={reload} id={id} marked={marked} name={name} comment={comment} phone={phone} email={email} date={date}></AptForm>
            </Grid>
          })}
        </Grid>
      </div>
  })}</div>
  
}

export const AptForm = (props) => {
  const classes = useStyles();
  const {name, comment, phone, date, email, id, marked, cancelled, reload} = props;
  const dateLabel = date.toLocaleDateString ('de-DE');
  const timeLabel = date.toLocaleTimeString ('de-DE').split (":").slice(0,2).join(':')
  return  <Card className={classes.card}>
    {cancelled&&<CardHeader className={classes.header2} title="Storniert">
      
    </CardHeader>}
    <CardHeader 
      className={classes.header} title={name}
      action={
        <ToggleMarkIconButton reload={reload} marked={marked} id={id} />
      }
    ></CardHeader>
    <CardContent>
      <Grid container justify="space-between" spacing={1}>
        {/*<Grid item xs={12}>
            <FullWidthTextField InputProps={{
              readOnly: true,
            }} value={name} label='Name'></FullWidthTextField>
          </Grid>*/}
        <Grid item xs={6}>
          <DisplayField InputProps={{
            readOnly: true,
          }} value={dateLabel} label='Datum' />
        </Grid>
        <Grid item xs={6}>
          <DisplayField InputProps={{
            readOnly: true,
          }} value={timeLabel} label='Uhrzeit' />
        </Grid>
        {phone&&<Grid item xs={12}>
          <DisplayField InputProps={{
            readOnly: true,
          }} multiline value={phone} label='Telefonnummer'/>
        </Grid>}    
        {email&&<Grid item xs={12}>
          <DisplayField InputProps={{
            readOnly: true,
          }} multiline value={email} label='E-Mail' />
        </Grid>}     
        {comment&&<Grid item xs={12}>
          <DisplayField InputProps={{
            readOnly: true,
          }} multiline value={comment} label='Kommentar'/>
        </Grid>}
      </Grid>
    </CardContent>
    <CardActions>
      <DeleteButton id={id} reload={reload}/>
    </CardActions>
  </Card>
}

const VisibilityToolbar = (props) => {
  const classes = useStyles();
  const {visible, onClick} = props;
  return <Paper square>
    <Toolbar>
      <IconButton onClick={onClick} className={classes.visIcon}>
        {!visible?<VisibilityOffIcon/>:<VisibilityIcon/>}
      </IconButton>
    </Toolbar>
  </Paper>
}

const DisplayField = (props) => {
  const { value, label, labelColor="primary" } = props;
  return <>
    <Typography color={labelColor} variant="caption">{label}</Typography>
    <Typography>{value}</Typography>
  </>
}
const DeleteButton = (props) => {
  const { id, reload} = props
  const [isLoading, setLoading] = useState(false);

  const onClick = async () => {
    setLoading (true);
    const res = await API.del('appointments', `/appointment/${id}`)
    await reload ();
    setLoading(false);
  }
  
  return <LoadingButton isLoading={isLoading} onClick={onClick} variant="contained" color="secondary">Löschen</LoadingButton>
}
const ToggleMarkIconButton = (props) => {
  const { marked, id, reload} = props
  const [isLoading, setLoading] = useState(false);

  const onClick = async () => {
    setLoading (true);
    const res = await API.post('appointments', `/appointment/${id}/mark`, {
      body: {
        marked: !marked
      }
    })
    await reload ();
    setLoading(false);
  }
  
  return <IconButton onClick={onClick} color={marked?"primary":"inherit"}>
      {isLoading?<CircularProgress size={20}/>:<DoneIcon />}
  </IconButton>
  return <LoadingButton isLoading={isLoading} onClick={onClick} variant={marked?"contained":"outlined"} color="primary">{marked?"Erledigt":"Erledigen"}</LoadingButton>
}
export default Overview;